import { render } from "./ColorPicker.vue?vue&type=template&id=94709e66"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"

import "./ColorPicker.vue?vue&type=style&index=0&id=94709e66&lang=scss"
script.render = render

export default script